<template>
  <v-container class="pa-0" :class="{ 'export-embedded': embedded }" fluid>
    <v-container v-if="!embedded" class="pt-6 pb-6 px-4" fluid>
      <v-row align="center" class="ma-0">
        <v-col cols="auto" class="py-0 pr-2">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Monat"
                v-model="monthFormatted"
                readonly
                outlined
                dense
                hide-details
                style="width: 150px;"
                color="#FF6600"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="month"
              no-title
              scrollable
              type="month"
              color="#FF6600"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="auto" class="py-0">
          <v-text-field
            v-model="searchText"
            label="Suche"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            hide-details
            clearable
            style="width: 250px;"
            color="#FF6600"
            @input="onSearchInput"
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="py-0 pr-1">
          <v-btn
            color="gray"
            class="px-2"
            height="40"
            min-width="40"
            elevation="0"
            style="border: thin solid rgba(0, 0, 0, 0.12);"
            @click="collapseAllClick"
          >
            <v-icon small color="grey darken-2">{{ expanded ? 'mdi-unfold-less-horizontal' : 'mdi-unfold-more-horizontal' }}</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto" class="py-0 pr-1">
          <v-btn
            color="gray"
            class="px-2"
            height="40"
            min-width="40"
            elevation="0"
            style="border: thin solid rgba(0, 0, 0, 0.12);"
            @click="refreshDataGrid"
          >
            <v-icon small color="grey darken-2">mdi-refresh</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto" class="py-0">
          <v-btn
            color="gray"
            class="px-2"
            height="40"
            min-width="40"
            elevation="0"
            style="border: thin solid rgba(0, 0, 0, 0.12);"
            @click="exportToCsv"
          >
            <v-icon small color="grey darken-2">mdi-download</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-divider v-if="!embedded"></v-divider>
    <dx-data-grid
      :ref="gridRefName"
      :data-source="datasource"
      :summary="summary"
      :show-borders="false"
      :show-column-lines="false"
      :column-auto-width="true"
      :allow-column-reordering="!gridTouch"
      :allow-column-resizing="!gridTouch"
      :hover-state-enabled="!gridTouch"
      :show-row-lines="true"
      :height="embedded ? '100%' : undefined"
      :error-row-enabled="!embedded"
      @toolbar-preparing="onToolbarPreparing($event)"
      :scrolling="scrolling"
    >
      <dx-group-panel :visible="false" />

      <dx-grouping :auto-expand-all="expanded" expandMode="rowClick" />
      <dx-paging :page-size="defaultPageSize" />
      <dx-pager
        :visible="!embedded"
        :show-page-size-selector="true"
        :allowed-page-sizes="pageSizes"
        :show-info="true"
        :info-text="'Seite {0} von {1} ({2} Verkäufe)'"
      />
      <dx-filter-row :visible="!embedded" />
      <dx-load-panel :enabled="!embedded" />
      <dx-export
        :enabled="false"
        :allow-export-selected-data="true"
        file-name="landshut"
        :texts="{ exportAll: 'Alles herunterladen', exportSelectedRows: 'Auswahl herunterladen', exportTo: 'Excel Download'}"
      />
    </dx-data-grid>
  </v-container>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxFilterRow,
  DxPager,
  DxExport,
  DxGrouping,
  DxGroupPanel,
  DxLoadPanel
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import axios from "axios";
import moment from "moment";
import { Parser } from "json2csv";
import DataGridMixin from "@/mixins/DataGridMixin";

export default {
  components: {
    DxDataGrid,
    DxPaging,
    DxFilterRow,
    DxPager,
    DxExport,
    DxGrouping,
    DxGroupPanel,
    DxLoadPanel
  },
  mixins: [DataGridMixin],
  props: {
    // eingebettet in die Seite Exporte: ohne eigene Leiste, Filterzeile, Pager, Ladeanzeige und Fehlerzeile
    embedded: { type: Boolean, default: false },
    // Berichtsmonat 'YYYY-MM' der Seite Exporte
    reportMonth: { type: String, default: null }
  },
  computed: {
    monthFormatted() {
      return moment(this.month).format("MM.YYYY");
    },
    dataUrl() {
      return `${this.$store.state.baseUrl}ticketsale?customer_id=${
        this.$store.state.customerId
      }&sale_month=${this.month.substring(
        5,
        7
      )}&sale_year=${this.month.substring(0, 4)}&option=landshutExport`;
    }
  },
  watch: {
    dataUrl: function() {
      this.refreshDataGrid();
    },
    reportMonth(value) {
      if (value && value !== this.month) {
        this.month = value;
      }
    }
  },
  data() {
    return {
      month: this.reportMonth || new Date().toISOString().substr(0, 7),
      menu: false,
      expanded: false,
      searchText: "",
      gridRefName: "landshutExportDataGrid",
      datasource: new CustomStore({
        load: () => axios.get(this.dataUrl)
      }),

      summary: {}
    };
  },
  methods: {
    refreshDataGrid() {
      const grid = this.$refs[this.gridRefName];
      if (grid && grid.instance) {
        grid.instance.refresh();
      }
    },
    onSearchInput() {
      if (this.$refs[this.gridRefName] && this.$refs[this.gridRefName].instance) {
        this.$refs[this.gridRefName].instance.searchByText(this.searchText || '');
      }
    },
    collapseAllClick() {
      this.expanded = !this.expanded;
    },
    async exportToCsv() {
      let data = await this.$refs[this.gridRefName].instance
        .getController("export")
        ._getAllItems(null)
        .promise();
      data = data
        .filter(item => item.rowType === "data")
        .map(item => item.data)
        .map(item => {
          item.Betrag = item.Betrag.replace(".", ",");
          item.ID = "\t" + item.ID;
          return item;
        });
      const fields = [
        "UnternehmerID",
        "ID",
        "EZONE",
        "AZONE",
        "Monat",
        "Jahr",
        "TarifStufe",
        "Betrag",
        "Anzahlkarten",
        "Gattung",
        "UmstStadtverkehr",
        "VZONE",
        "DatumZeit",
        "sid",
        "sDatumZeit",
        "Linie",
        "Fahrt",
        "VHST",
        "NHST",
        "FahrerNr",
        "druckernr",
        "gueltig"
      ];
      const opts = { fields, delimiter: ";", quote: '"' };
      const parser = new Parser(opts);
      const csv = parser.parse(data);
      this.download(
        `Landshut${this.$store.state.customerId}_${
          this.$store.state.customerName
        }_${this.month.substring(0, 4)}_${this.month.substring(5, 7)}.csv`,
        csv
      );
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    onToolbarPreparing() {
      // Buttons are now in the filter row, no toolbar buttons needed
    }
  }
};
</script>

<style scoped>
/* eingebettet (Exporte): Flex-Spalte mit voller Höhe, das Grid füllt sie */
.export-embedded {
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: left;
}
</style>
